//COMPONENTS
import CustomModal from "../../../../../../components/CustomModal/CustomModal";
import { ModalContent } from "@nextui-org/react";
import Button from "../../../../../../components/Button/Button";

//STYLES
import styles from "./CancelOperationModal.module.scss";

//ASSETS
import DiscardChanges from "../../../../../../assets/images/illustrations/discard-changes.svg?react";

interface Props {
  handleClose: () => void;
  handleGoBack: () => void;
  isEditOperation?: boolean;
  title?: string;
}

const CancelOperationModal = ({
  handleClose,
  handleGoBack,
  isEditOperation,
  title,
}: Props) => {
  const { content, header, image, body, description, buttons, button } = styles;

  return (
    <CustomModal
      isOpen={true}
      onClose={handleClose}
      hideCloseButton
      isDismissable={false}
      isKeyboardDismissDisabled
    >
      <ModalContent className={content}>
        <div className={image}>
          <DiscardChanges />
        </div>
        <div className={header}>
          <span>
            {title ??
              (isEditOperation
                ? "¿Cancelar edición de la orden?"
                : "¿Cancelar operación?")}
          </span>
        </div>
        <div className={body}>
          <div className={description}>
            <span>Se perderán todos los datos ingresados.</span>
          </div>
          <div className={buttons}>
            <Button
              className={button}
              text="No, volver"
              variant="secondary"
              onPress={handleGoBack}
            />

            <Button
              className={button}
              text="Sí, cancelar"
              onPress={handleClose}
            />
          </div>
        </div>
      </ModalContent>
    </CustomModal>
  );
};

export default CancelOperationModal;
